import { Switch } from "neetoui";
import { isEmpty } from "ramda";

import { SWITCH_OPTIONS } from "../constants";

const SwitchOptions = ({ customization = {}, updateCustomization }) => {
  const visibleOptions = Object.keys(SWITCH_OPTIONS)
    .filter(key => key in customization)
    .map(key => [key, customization[key]]);

  if (isEmpty(visibleOptions)) return null;

  return (
    <div className="flex flex-col gap-4">
      {visibleOptions.map(
        ([option, { value, label, helpIconProps, ...rest }]) => (
          <Switch
            checked={value}
            key={option}
            label={label || SWITCH_OPTIONS[option].label}
            labelProps={
              helpIconProps && {
                helpIconProps: {
                  "data-testid": "help-icon-button",
                  ...helpIconProps,
                },
              }
            }
            onChange={e =>
              updateCustomization({
                [option]: {
                  ...rest,
                  label,
                  helpIconProps,
                  value: e.target.checked,
                },
              })
            }
          />
        )
      )}
    </div>
  );
};

export default SwitchOptions;
